import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatePipe } from '@angular/common'
import { ItineraryTypeMslMonitoringKpi } from 'src/app/assabil-sales/models/dtos/itinerary-type-msl-monitoring-kpi';

@Component({
  selector: 'msl-monitoring-kpi',
  templateUrl: './msl-monitoring-kpi.component.html',
  styleUrls: ['./msl-monitoring-kpi.component.scss']
})
export class MslMonitoringKpiComponent implements OnInit {

  @Input() geoArea    ;
  @Input() itineraryTypeMslMonitoringKpi : ItineraryTypeMslMonitoringKpi;

  @Output() onClick        = new EventEmitter<any>();
  @Input() previousPeriod      : string;

  
  constructor(protected datepipe: DatePipe) { }

  ngOnInit() {
  }


  clickTitle()            { this.onClick.emit({itineraryTypeName : this.itineraryTypeMslMonitoringKpi.itineraryTypeName, itineraryType : this.itineraryTypeMslMonitoringKpi.itineraryTypeCode, partnerCluster : this.itineraryTypeMslMonitoringKpi.partnerClusterCode, geoArea : this.geoArea, kpi : "Count"} );} 
  clickInvoicedPartners() { this.onClick.emit({itineraryTypeName : this.itineraryTypeMslMonitoringKpi.itineraryTypeName, itineraryType : this.itineraryTypeMslMonitoringKpi.itineraryTypeCode, partnerCluster : this.itineraryTypeMslMonitoringKpi.partnerClusterCode, geoArea : this.geoArea, kpi : "InvoicedPartners"} );} 
  
  getInvoicedPartnersRate(itineraryTypeMslMonitoringKpi : ItineraryTypeMslMonitoringKpi) {
    return Math.round((itineraryTypeMslMonitoringKpi.totalPartnersCount !=0 ? (itineraryTypeMslMonitoringKpi.invoicedPartnersCount * 100 / itineraryTypeMslMonitoringKpi.totalPartnersCount) : 0));
  }

}